import React, { Component } from 'react';
import PropTypes from 'prop-types';

import cx from 'classnames';
import s from './HeaderContentActions.css';


export default class HeaderContentActions extends Component {
  static propTypes = {
    children: PropTypes.node,
    title: PropTypes.string,
    className: PropTypes.string,
  }

  componentWillMount() {
    this.setState({
      children: this.props.children,
    });
  }

  render() {
    return (
      <section className={cx(s.component, this.props.className)}>
        {this.props.children}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/HeaderBar/HeaderContentActions.js